/**
 * Created by lvardarova on 28/04/16.
 */
import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Confirm(props) {
    return (
        <SvgIcon {...props}>
            <polygon points="11.187,1.767 4.25,9.299 1.661,6.684 0,8.381 4.421,12.767 13,3.494" />
        </SvgIcon>
    );
}

Confirm.defaultProps = {
    viewBox: '0 0 13 16'
};

export default Confirm;
